import { render, staticRenderFns } from "./CouponBanner.vue?vue&type=template&id=79be2271&scoped=true&"
var script = {}
import style0 from "./CouponBanner.vue?vue&type=style&index=0&id=79be2271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be2271",
  null
  
)

export default component.exports